import mnLang from './entries/mn_MN';
import enLang from './entries/en_US';

const AppLocale = {
    mn: mnLang,
    en: enLang
};

export default AppLocale;